import React from 'react';
import { LabelField } from '../../components/Admin';

export default class Vision extends React.Component {
	render(){
		var { website, onChangeProp } = this.props;
		return (
			<div>
				<LabelField defaultValue={website.visionTitle} onChange={onChangeProp} prop="visionTitle" name="Título" info="40 caracteres" />
				<LabelField defaultValue={website.vision} onChange={onChangeProp} prop="vision" name="Descripción" info="110 caracteres" rows={8} />
				{/* <ImageField defaultValue={website.signatureImage} onChange={onChangeImage} prop="signatureImageId" name="Firma" info="svg o png" /> */}
				<LabelField defaultValue={website.signatureName} onChange={onChangeProp} prop="signatureName" name="Nombre del que firma" info="110 caracteres" rows={1} />
				<LabelField defaultValue={website.signaturePosition} onChange={onChangeProp} prop="signaturePosition" name="Cargo" rows={1} />
			</div>
		)
	}
}
